module.exports = __webpack_public_path__ + "img/picture_default.0139b240.png";